'use client';
import useNetworks from '#/data/useNetworks';
import useWatcherNetworks, {
  useWatcherNetworkAPR,
} from '#/data/useWatcherNetworks';
import formatUnits from '#/utils/formatUnits';
import parseUnits from '#/utils/parseUnits';
import Skeleton from './Skeleton';

interface Props {
  symbol?: string;
}

export default function WatcherNetworkAPR({ symbol }: Props) {
  const { isLoading: isNetworksLoading } = useNetworks();
  const { isLoading: isWatcherNetworksLoading } = useWatcherNetworks();
  const apr = useWatcherNetworkAPR(symbol);
  return (
    <Skeleton
      isLoading={isNetworksLoading || isWatcherNetworksLoading}
      className="w-16"
    >
      {apr ? `${formatUnits(parseUnits(apr, 8), 8, 2)}%` : null}
    </Skeleton>
  );
}
